import { all, put, takeEvery, call } from 'redux-saga/effects';
import actions from './actions';
import { getRequest } from '../../../../helpers/axiosClient';

export function* getDashboard(params) {
    try {
        let response = yield call(() => getRequest(params.url));
        yield put({
            type: actions.PRODUCT_DASHBOARD_SUCCESS,
            payload: response?.data
        });
    } catch (error) {
        yield put({ type: actions.PRODUCT_DASHBOARD_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getProductWiseAnalysis(params) {
    try {
        let response = yield call(() => getRequest(params.url));
        yield put({
            type: actions.PRODUCT_WISE_ANALYSIS_SUCCESS,
            payload: response?.data
        });
    } catch (error) {
        yield put({ type: actions.PRODUCT_WISE_ANALYSIS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export default function* productDashboardSaga() {
    yield all([
        takeEvery(actions.PRODUCT_DASHBOARD_START, getDashboard),
        takeEvery(actions.PRODUCT_WISE_ANALYSIS_START, getProductWiseAnalysis)
    ]);
}